module.exports = __webpack_public_path__ + "img/Cert_1131500355.c623b93d.jpg";